(function() {
  // Handle opt-out of personalise form
  const personaliseOptOut = document.getElementById('personaliseOptOut');
  if (personaliseOptOut) {
    const personaliseFieldsets = document.querySelectorAll('.js-personalise-fieldset');
    personaliseOptOut.addEventListener('change', function() {
      let fieldsetIndex = 0;
      if (this.checked) {
        personaliseFieldsets.forEach(elem => {
          elem.setAttribute('disabled', '');
        });
      } else {
        personaliseFieldsets.forEach(elem => {
          // Only enable the previously active fieldset on toggle
          const elemType = elem.nodeName.toLowerCase();
          if (elemType === "fieldset" && elem.classList.contains('hidden')) {
            return;
          }
          elem.removeAttribute('disabled'); 
        });
      }
    });
  }
    
  // Font dropdowns
  const fontDropdowns = document.querySelectorAll('[data-personalise-font]');
  if (fontDropdowns) {
    fontDropdowns.forEach(select => {
      select.addEventListener('change', (e) => {
        const imageAsset = e.target.selectedOptions[0].dataset.fileName;
        if (imageAsset) {
          e.target.setAttribute('data-font-bg', imageAsset);
        }
      })
    });
  }

  // Toggles open accordions
  const accordions = document.querySelectorAll('[data-personalise-accordion]');
  if (accordions) {
    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.personalise-form__options--checkbox');
      toggle.addEventListener('change', (e) => {
        const body = accordion.querySelector('[data-personalise-body]');
        if (toggle.checked) {
          body.classList.remove('hidden');
          body.removeAttribute('disabled');
          body.setAttribute('aria-hidden', false);
        } else {
          body.classList.add('hidden');
          body.disabled = true;
          body.setAttribute('aria-hidden', true);
        }
      });
    });
  };
  
  const tabLinks = document.querySelectorAll('[data-form-toggle]');
  
  // Toggles open tab content
  if (tabLinks) {
    tabLinks.forEach(link => {  
      link.addEventListener('click', (e) => {

        let linkContainer = "";
        
        if (link.closest('[data-personalise-container]')) {
          linkContainer = link.closest('[data-personalise-container]');
        } else if (link.closest('[data-personalise-accordion]')) {
          linkContainer = link.closest('[data-personalise-accordion]');
        } else {
          linkContainer = link.closest('#personaliseForm');
        }
        
        const tabsContent = linkContainer.querySelectorAll('[data-form-tab]');

        if (!tabsContent) return

        tabsContent.forEach(tab => {
          tab.classList.add('hidden');
          tab.setAttribute('aria-hidden', true);
          if (tab.nodeName === "FIELDSET") tab.disabled = true;
        })

        const target = linkContainer.querySelector(`[data-form-tab="${link.getAttribute('data-form-toggle')}"]`);

        if (!target || link.getAttribute('data-form-toggle').toUpperCase === "NONE") return;

        if (target.classList.contains('hidden')) {
          target.classList.remove('hidden');
          target.removeAttribute('aria-hidden');
          if (target.nodeName === "FIELDSET") target.disabled = false;
        }
      })
    });
  }
}());